<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>

          <b-row>
            <b-col sm="12">

<!--              **{{qn_work_status}}-->
              <b-card v-if="qn_work_status==3 || qn_work_status==4" header-class="redmfu">
                <div slot="header" v-if="thai_student==1">
                  <strong>ตอนที่ 3 สำหรับผู้ที่ยังไม่ทำงาน</strong>
                </div>
                <div slot="header" v-if="thai_student==0">
                  <strong>Part 3 For graduates not yet employed</strong>
                </div>
<!--                == {{ items }}-->
                <div v-for="item in items" v-bind:key="item.QUESTION_PK">

                  <div v-if=" item.QUESTION_PK==34">
                    <!--                      {{item.QUESTION_PK}}) -->
                    <strong>27. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p v-if="selected_cause_nowork==0">{{ selected_cause_nowork }} : {{ ans33 }}
                      <u>{{ qn_cause_nowork_txt }} </u></p>
                    <p v-else>{{ selected_cause_nowork }} : {{ ans33 }} </p>
                  </div>
                  <div v-if=" item.QUESTION_PK==35">
                    <!--                      {{item.QUESTION_PK}})-->
                    <strong>28. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p v-if="selected_prob_findwork_0==1">0 : {{ ans35_0 }} <u>{{ qn_prob_findwork_txt }} </u></p>
                    <p v-if="selected_prob_findwork_1==1 && thai_student==1">1 : ไม่มีปัญหา </p>
                    <p v-if="selected_prob_findwork_1==1 && thai_student==0">1 : No </p>
                    <p v-if="selected_prob_findwork_2==1">2 : {{ ans35_2 }} </p>
                    <p v-if="selected_prob_findwork_3==1">3 : {{ ans35_3 }} </p>
                    <p v-if="selected_prob_findwork_4==1">4 : {{ ans35_4 }} </p>
                    <p v-if="selected_prob_findwork_5==1">5 : {{ ans35_5 }} </p>
                    <p v-if="selected_prob_findwork_6==1">6 : {{ ans35_6 }} </p>
                    <p v-if="selected_prob_findwork_7==1">7 : {{ ans35_7 }} </p>
                    <p v-if="selected_prob_findwork_8==1">8 : {{ ans35_8 }} </p>
                    <p v-if="selected_prob_findwork_9==1">9 : {{ ans35_9 }} </p>
                    <p v-if="selected_prob_findwork_10==1">10 : {{ ans35_10 }} </p>
                    <p v-if="selected_prob_findwork_11==1">11 : {{ ans35_11 }} </p>
                    <p v-if="selected_prob_findwork_12==1">12 : {{ ans35_12 }} </p>
                    <p v-if="selected_prob_findwork_13==1">13 : {{ ans35_13 }} </p>
                    <p v-if="selected_prob_findwork_14==1">14 : {{ ans35_14 }} </p>

                  </div>
                  <div v-if=" item.QUESTION_PK==36">
                    <!--                      {{item.QUESTION_PK}}) -->
                    <strong>29. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ selected_workneed_id }} : {{ ans36 }} </p>
                  </div>


                </div>


              </b-card>

              <b-card v-if="selected_workneed_id==2">
                <div slot="header" v-if="thai_student==1">
                  <strong>ตอนที่ 3 สำหรับผู้ที่ยังไม่ทำงาน และต้องการทำงาน<u>ในต่างประเทศ</u></strong>
                </div>
                <div v-for="item1 in item1s" v-bind:key="item1.QUESTION_PK">
                  <div v-if=" item1.QUESTION_PK==37">
                    <!--                      {{item1.QUESTION_PK}}) -->
                    <strong>30. {{ item1.QUESTION_NAME }}</strong> {{ select_country }} : {{ ans37 }}
                  </div>
                  <div v-if=" item1.QUESTION_PK==38">
                    <!--                      {{item1.QUESTION_PK}}) -->
                    <strong>31. {{ item1.QUESTION_NAME }}</strong>
                    <br/>
                    <p v-if="thai_student==1">{{ select_position }} : {{ ans38 }} </p>
                    <p v-else>{{ current_position }} </p>
                  </div>
                  <div v-if=" item1.QUESTION_PK==39">
                    <!--                      {{item1.QUESTION_PK}})-->
                    <strong>32. {{ item1.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ current_skill }} </p>
                  </div>
                  <div v-if=" item1.QUESTION_PK==40">
                    <!--                    {{item1.QUESTION_PK}}) -->
                    <strong>33. {{ item1.QUESTION_NAME }} </strong>
                    <br/>
                    <p>{{ selected_disclosure }}: {{ ans40 }} </p>
                  </div>
                  <div v-if=" item1.QUESTION_PK==41">
                    <!--                      {{item1.QUESTION_PK}}) -->
                    <strong>34. {{ item1.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ selected_require_edu }} : {{ ans41 }} </p>
                  </div>
                </div>
                <div slot="footer" class="text-right" >
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>
                  <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                    <i class="fa fa-arrow-circle-o-right"></i> Next
                  </b-button>
                </div>


              </b-card>
              <b-card v-if="selected_workneed_id==1">
                <div slot="header" v-if="thai_student==1">
                  <strong>ตอนที่ 3 สำหรับผู้ที่ยังไม่ทำงาน และต้องการทำงาน<u>ในประเทศไทย</u></strong>
                </div>
                <div slot="header" v-if="thai_student==0">
                  <strong>Part 3 For graduates not yet employed</strong>
                </div>
                <!-- <b-card v-if="selected_workneed_id==1" header-bg-variant=primary> -->
                <div v-for="item1 in item1s" v-bind:key="item1.QUESTION_PK">

                  <div v-if=" item1.QUESTION_PK==38">
                    <!--                      {{item1.QUESTION_PK}}) -->
                    <strong>31. {{ item1.QUESTION_NAME }}</strong>
                    <br/>
                    <p v-if="thai_student==1">{{ select_position }} : {{ ans38 }} </p>
                    <p v-else>{{ current_position }} </p>
                  </div>
                  <div v-if=" item1.QUESTION_PK==39">
                    <!--                      {{item1.QUESTION_PK}}) -->
                    <strong>32. {{ item1.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ current_skill }} </p>
                  </div>
                  <div v-if=" item1.QUESTION_PK==40">
                    <!--                      {{item1.QUESTION_PK}}) -->
                    <strong>33. {{ item1.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ selected_disclosure }}: {{ ans40 }} </p>
                  </div>
                  <div v-if=" item1.QUESTION_PK==41">
                    <!--                      {{item1.QUESTION_PK}}) -->
                    <strong>34. {{ item1.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ selected_require_edu }} : {{ ans41 }} </p>
                  </div>
                </div>
                <div slot="footer" class="text-right" >
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>
                  <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                    <i class="fa fa-arrow-circle-o-right"></i> Next
                  </b-button>
                </div>

              </b-card>
            </b-col>
          </b-row>

        </b-col>
      </b-row>
<!--      <b-row>-->
<!--        <b-col>-->
<!--        <div align="center">-->
<!--          <b-col cols="7" sm="4" md="2" xl class="mb-3 mb-xl-0">-->
<!--            <b-button block variant="primary" @click="onSubmit"><i class="fa fa-arrow-circle-o-right"></i> Next-->
<!--            </b-button>-->
<!--          </b-col>-->
<!--        </div>-->
<!--        </b-col>-->
<!--      </b-row>-->
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      std_id: "",
      student: {},
      selected: "",
      sex: "",
      studentCode: "",
      thai_student: "",
      prefixName: "",
      studentName: "",
      studentSurname: "",
      studentNameEng: "",
      studentSurnameEng: "",
      prefixNameEng: "",
      levelGroupNameEng: "",
      facultyName: "",
      facultyNameEng: "",
      departmentName: "",
      departmentNameEng: "",
      current_erorrtxt: "",
      dangerModal: false,

      items: [],
      item1s: [],
      selected_cause_nowork: "",
      qn_cause_nowork_txt: "",
      selected_prob_findwork: "",
      qn_prob_findwork_txt: "",
      selected_workneed_id: "",

      current_country_name: "Thailand",
      countryItems: [],
      select_country: 'TH',

      select_position: "",
      positionItems: [],
      current_position: "",
      current_skill: "",
      selected_disclosure: "",
      selected_require_edu: "",
      ans33: "",
      ans35_0: "",
      ans35_1: "",
      ans35_2: "",
      ans35_3: "",
      ans35_4: "",
      ans35_5: "",
      ans35_6: "",
      ans35_7: "",
      ans35_8: "",
      ans35_9: "",
      ans35_10: "",
      ans35_11: "",
      ans35_12: "",
      ans35_13: "",
      ans35_14: "",
      ans36: "",
      ans37: "",
      ans38: "",
      ans39: "",
      ans40: "",
      ans41: "",
      selected_prob_findwork_0: "",
      selected_prob_findwork_1: "",
      selected_prob_findwork_2: "",
      selected_prob_findwork_3: "",
      selected_prob_findwork_4: "",
      selected_prob_findwork_5: "",
      selected_prob_findwork_6: "",
      selected_prob_findwork_7: "",
      selected_prob_findwork_8: "",
      selected_prob_findwork_9: "",
      selected_prob_findwork_10: "",
      selected_prob_findwork_11: "",
      selected_prob_findwork_12: "",
      selected_prob_findwork_13: "",
      selected_prob_findwork_14: "",
      qn_work_status: ""
    };
  },

  methods: {
    getAns(question, ans, thaistudent) {
      api
        .getSybytedesByAns(question, ans, thaistudent)
        .then(res => {
          var currentSt = res.data.data[0];
          // console.log(res.data.data[0]);
          if (res.data.data.length > 0) {
            if (question == "QN_CAUSE_NOWORK") {
              this.ans33 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 0)) {
              this.ans35_0 = res.data.data[0].BYTEDES;
            }
            // if ( (question == "QN_PROB_FINDWORK")&& (ans==1) ){
            //   this.ans35_1 = "ไม่มีปัญหา";
            // }
            if ((question == "QN_PROB_FINDWORK") && (ans == 2)) {
              this.ans35_2 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 3)) {
              this.ans35_3 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 4)) {
              this.ans35_4 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 5)) {
              this.ans35_5 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 6)) {
              this.ans35_6 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 7)) {
              this.ans35_7 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 8)) {
              this.ans35_8 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 9)) {
              this.ans35_9 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 10)) {
              this.ans35_10 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 11)) {
              this.ans35_11 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 12)) {
              this.ans35_12 = res.data.data[0].BYTEDES;
              //  console.log("this.ans8== ", this.ans8);
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 13)) {
              this.ans35_13 = res.data.data[0].BYTEDES;
              //  console.log("this.ans8== ", this.ans8);
            }
            if ((question == "QN_PROB_FINDWORK") && (ans == 14)) {
              this.ans35_14 = res.data.data[0].BYTEDES;
            }
            if ((question == "QN_WORKNEED_ID")) {
              this.ans36 = res.data.data[0].BYTEDES;
            }

            if ((question == "QN_DISCLOSURE_AGREEMENT_ID")) {
              this.ans40 = res.data.data[0].BYTEDES;
              // console.log("this.ans40",this.ans40);
            }
            if ((question == "QN_REQUIRE_EDU")) {
              this.ans41 = res.data.data[0].BYTEDES;
              // console.log("this.ans41",this.ans41);
            }

          }
        })
        .catch(err => {

          console.log("getSybytedesByAns", err.toString());
        });

    },
    getQuestion: function (section, sex, thaistudent) {
      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          if (section == 3) {
            this.items = res.data.data;
            //console.log(this.items);
          } else if (section == 31) {
            this.item1s = res.data.data;
          //  console.log(this.item1s);
          }
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("length==",res.data.data.length)
          if (res.data.data.length > 0) {
            var currentSt = res.data.data[0];
            // console.log("currentSt==",currentSt)
            this.std_id = studentid;
            this.thai_student = currentSt.THAI_STUDENT;
            this.sex = currentSt.SEX;
            this.selected_cause_nowork = currentSt.QN_CAUSE_NOWORK;
            this.qn_cause_nowork_txt = currentSt.QN_CAUSE_NOWORK_TXT;
            this.qn_work_status = currentSt.QN_WORK_STATUS;
            // console.log("qn_work_status==", currentSt.QN_WORK_STATUS);
            if (this.qn_work_status == 3 || this.qn_work_status == 4) {

              this.qn_prob_findwork_txt = currentSt.QN_PROB_FINDWORK_TXT;

              var selectedData = [];
              var j = -1;
              if (currentSt.QN_PROB_FINDWORK0 != null) {
                j = j + 1;
                selectedData[j] = 0;
              }
              if (currentSt.QN_PROB_FINDWORK != null) {
                j = j + 1;
                selectedData[j] = 1;
              }
              if (currentSt.QN_PROB_FINDWORK2 != null) {
                j = j + 1;
                selectedData[j] = 2;
              }
              if (currentSt.QN_PROB_FINDWORK3 != null) {
                j = j + 1;
                selectedData[j] = 3;
              }
              if (currentSt.QN_PROB_FINDWORK4 != null) {
                j = j + 1;
                selectedData[j] = 4;
              }
              if (currentSt.QN_PROB_FINDWORK5 != null) {
                j = j + 1;
                selectedData[j] = 5;
              }
              if (currentSt.QN_PROB_FINDWORK6 != null) {
                j = j + 1;
                selectedData[j] = 6;
              }
              if (currentSt.QN_PROB_FINDWORK7 != null) {
                j = j + 1;
                selectedData[j] = 7;
              }
              if (currentSt.QN_PROB_FINDWORK8 != null) {
                j = j + 1;
                selectedData[j] = 8;
              }
              if (currentSt.QN_PROB_FINDWORK9 != null) {
                j = j + 1;
                selectedData[j] = 9;
              }
              if (currentSt.QN_PROB_FINDWORK10 != null) {
                j = j + 1;
                selectedData[j] = 10;
              }
              if (currentSt.QN_PROB_FINDWORK11 != null) {
                j = j + 1;
                selectedData[j] = 11;
              }
              if (currentSt.QN_PROB_FINDWORK12 != null) {
                j = j + 1;
                selectedData[j] = 12;
              }
              if (currentSt.QN_PROB_FINDWORK13 != null) {
                j = j + 1;
                selectedData[j] = 13;
              }
              if (currentSt.QN_PROB_FINDWORK14 != null) {
                j = j + 1;
                selectedData[j] = 14;
              }
              this.selected_prob_findwork = selectedData;
              this.selected_prob_findwork_0 = currentSt.QN_PROB_FINDWORK0;
              this.selected_prob_findwork_1 = currentSt.QN_PROB_FINDWORK;
              this.selected_prob_findwork_2 = currentSt.QN_PROB_FINDWORK2;
              this.selected_prob_findwork_3 = currentSt.QN_PROB_FINDWORK3;
              this.selected_prob_findwork_4 = currentSt.QN_PROB_FINDWORK4;
              this.selected_prob_findwork_5 = currentSt.QN_PROB_FINDWORK5;
              this.selected_prob_findwork_6 = currentSt.QN_PROB_FINDWORK6;
              this.selected_prob_findwork_7 = currentSt.QN_PROB_FINDWORK7;
              this.selected_prob_findwork_8 = currentSt.QN_PROB_FINDWORK8;
              this.selected_prob_findwork_9 = currentSt.QN_PROB_FINDWORK9;
              this.selected_prob_findwork_10 = currentSt.QN_PROB_FINDWORK10;
              this.selected_prob_findwork_11 = currentSt.QN_PROB_FINDWORK11;
              this.selected_prob_findwork_12 = currentSt.QN_PROB_FINDWORK12;
              this.selected_prob_findwork_13 = currentSt.QN_PROB_FINDWORK13;
              this.selected_prob_findwork_14 = currentSt.QN_PROB_FINDWORK14;
              this.selected_workneed_id = currentSt.QN_WORKNEED_ID;
              // console.log("currentSt.QN_WORKNEED_ID==",currentSt.QN_WORKNEED_ID)
              this.select_country = currentSt.QN_WORKNEED_NATION;
              // if (this.select_country !=''){
              //   this.getCountryId(this.select_country,this.thai_student);
              // }
              this.select_position = currentSt.QN_WORKNEED_POSITION;
              this.current_position = currentSt.QN_WORKNEED_POSITION_ENG;
              // console.log("QN_WORKNEED_POSITION_ENG==",currentSt.QN_WORKNEED_POSITION_ENG)
              this.current_skill = currentSt.QN_SKILL_DEVELOPMENT;
              this.selected_disclosure = currentSt.QN_DISCLOSURE_AGREEMENT_ID;
              this.selected_require_edu = currentSt.QN_REQUIRE_EDU;
              // console.log("449==", this.sex, this.thai_student);
              this.getQuestion(3, this.sex, this.thai_student);
              this.getQuestion(31, this.sex, this.thai_student);
              this.getAns("QN_CAUSE_NOWORK", this.selected_cause_nowork, this.thai_student);
              var ans = "";
              if (this.selected_prob_findwork_0 == 1) {
                ans = 0;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_1 == 1) {
                ans = 1;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_2 == 1) {
                ans = 2;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_3 == 1) {
                ans = 3;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_4 == 1) {
                ans = 4;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_5 == 1) {
                ans = 5;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_6 == 1) {
                ans = 6;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_7 == 1) {
                ans = 7;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_8 == 1) {
                ans = 8;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_9 == 1) {
                ans = 9;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_10 == 1) {
                ans = 10;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_11 == 1) {
                ans = 11;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_12 == 1) {
                ans = 12;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_13 == 1) {
                ans = 13;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              if (this.selected_prob_findwork_14 == 1) {
                ans = 14;
                this.getAns("QN_PROB_FINDWORK", ans, this.thai_student);
              }
              this.getAns("QN_WORKNEED_ID", this.selected_workneed_id, this.thai_student);
              // console.log("selected_workneed_id==",this.selected_workneed_id)
              if (this.selected_workneed_id == 2) {
                this.getCountryId(this.select_country, this.thai_student);
              }
              this.getPositionId(this.select_position);
              this.getAns("QN_DISCLOSURE_AGREEMENT_ID", this.selected_disclosure, this.thai_student);
              this.getAns("QN_REQUIRE_EDU", this.selected_require_edu, this.thai_student);
            }//end qn_work_status
          }
        })
        .catch(err => {

          console.log(2);
          console.log("getCurrentStudent", err.toString());

        });

    },
    onBack(){
      this.$router.push("employment");
    },
    onSubmit() {
      if (this.selected_require_edu == 1) {
        this.$router.push("employment4");
      } else {
        this.$router.push("employment5");
      }
    },
    getStudentByID(studentId) {
      api
        .getStudentByID(studentId)
        .then(res => {
          // console.log(res);
          var info = res.data.data[0];
          this.sex = info.SEX;
          // console.log("sex=", this.sex);
          this.thai_student = info.THAI_STUDENT;
          // console.log("thai_student=", this.thai_student);
          this.studentId = info.STUDENTID;
          this.studentCode = info.STUDENTCODE;
          this.prefixName = info.PREFIXNAME;
          this.studentSurname = info.STUDENTSURNAME;
          this.studentName = info.STUDENTNAME;
          this.prefixNameEng = info.PREFIXNAMEENG;
          this.studentNameEng = info.STUDENTNAMEENG;
          this.studentSurnameEng = info.STUDENTSURNAMEENG;
          this.LEVELGROUPNAME = info.LEVELGROUPNAME;
          this.departmentName = info.DEPARTMENTNAME;
          this.departmentNameEng = info.DEPARTMENTNAMEENG;
          this.facultyName = info.FACULTYNAME;
          this.facultyNameEng = info.FACULTYNAMEENG;
          this.levelGroupNameEng = info.LEVELGROUPNAMEENG;
          // this.getQuestion(3, this.sex, this.thai_student);
          // this.getQuestion(31, this.sex, this.thai_student);

          // this.getCurrentStudent();
        })
        .catch(err => {
          console.log("2 getStudentByID");
          console.log("2", err.toString());
        });
    },


    getStudentAns() {
    },


    getPositionId(postionid) {
      api
        .getPositionById(postionid)
        .then(res => {
          this.ans38 = res.data.data[0].POS_NAME;
          // console.log("ans6==", this.ans6);
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    },
    selectCountryOnchange: function () {
      api
        .getCountryById(this.select_country)
        .then(res => {
          console.log(
            "685COUNTRYNAME selectCountryOnchange ==",
            res.data.data[0].COUNTRYNAME
          );
          this.current_country_name = res.data.data[0].COUNTRYNAME;
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    },
    getCountryId(countryid, thai_student) {
      api
        .getCountryById(countryid, thai_student)
        .then(res => {
          if (res.data.data.length == 1) {
            this.ans37 = res.data.data[0].COUNTRYNAME
            //    console.log("this.ans31==",this.ans31);
          }
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
          return "";
        });
    },
    getPosition() {
      api
        .getPositionAll()
        .then(res => {
          this.positionItems = res.data.data;
          // console.log("positionItems==", res.data.data);
        })
        .catch(err => {
          console.log("getPositionAll", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/login");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);

  }
};
</script>
<style>
</style>
